import React from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import { MenuItem, Popover, Select } from '@mui/material';

export const RichTextEditorForContract = ({ anchorEl, onClose, onDelete, onStyleChange, isEditing }) => {
  const fontFamilies = ['Arial', 'Times New Roman', 'Courier New', 'Georgia'];
  const fontSizes = ['8', '10', '12', '14', '16', '18', '20', '24'];

  return (
    <Popover
      open={Boolean(anchorEl) && isEditing}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}>
      <div className="rich-text-toolbar">
        <button onClick={() => onStyleChange('bold')} className="toolbar-button">
          <FormatBoldIcon />
        </button>
        <button onClick={() => onStyleChange('italic')} className="toolbar-button">
          <FormatItalicIcon />
        </button>
        <button onClick={() => onStyleChange('underline')} className="toolbar-button">
          <FormatUnderlinedIcon />
        </button>
        <div className="toolbar-separator" />
        <Select
          className="font-select"
          onChange={(e) => onStyleChange('fontFamily', e.target.value)}
          defaultValue={fontFamilies[0]}
          size="small">
          {fontFamilies.map((font) => (
            <MenuItem key={font} value={font} style={{ fontFamily: font }}>
              {font}
            </MenuItem>
          ))}
        </Select>
        <Select
          className="font-size-select"
          onChange={(e) => onStyleChange('fontSize', e.target.value)}
          defaultValue={fontSizes[2]}
          size="small">
          {fontSizes.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
        <div className="toolbar-separator" />
        <button onClick={() => onStyleChange('bulletList')} className="toolbar-button">
          <FormatListBulletedIcon />
        </button>
        <button onClick={() => onStyleChange('numberList')} className="toolbar-button">
          <FormatListNumberedIcon />
        </button>
        <div className="toolbar-separator" />
        <button onClick={onDelete} className="toolbar-button delete-button">
          <DeleteOutlineIcon />
        </button>
      </div>
    </Popover>
  );
};

// Update renderFieldContent
